import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiCard, EuiImage, EuiHorizontalRule } from '@elastic/eui';
import { Header } from './components/header';
import { Footer } from './components/footer';
import profilePhoto from '../photos/nikhil-pawar.jfif'

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            skills: ["Deep learning", "Data Analysis", "Research Machine", "Learning Innovation", "Rational Analytics", "Multi-Disciplinary", "CNN", "AI", "Computer vision"],
            shortTerm: ['Engineering Judgement',
            '	 Scholarship for advanced studies',
            'E.I.T  Certified ',
            ' Research competency',
            ' M.S (thesis)'
            ],
            midTerm: ['	 Contribute in Professional Bodies',
            	'Innovations ',
            	'PE License',
            	'Ph.D. Degree ',
            	  'Financial Stability',
            ],
            longTerm: ['	Post-Doctorate',
            	'Academic Position',
            	'Applied Research',
            	'Entrepreneur',
            	'Structural Consultant'
            ]
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                <EuiSpacer /><EuiFlexGroup justifyContent='spaceBetween'>
                    <EuiFlexItem grow={false}>
                    <EuiText><span><font face="Courier New" size="50px"><h1 style={{display: "inline"}}>Nikhil Mukund Pawar</h1><h4 style={{display: "inline"}}>, B.Tech (Civil)</h4></font></span></EuiText>
                    <EuiHorizontalRule margin='xs' />
                    <EuiText><span>Affiliated Member, ASCE, Student Member ACI, Student Member ICI</span></EuiText>
                    <EuiSpacer />
                    <EuiText><h2><u>Vision</u></h2>
                    <p>Teach, Practice, Innovate and Venture in Engineering.</p></EuiText>
                    <EuiSpacer size='m' />
                    <EuiText><h2><u>Mission</u></h2>
                    <p>To Acquire Highest Training in Structural Engineering and Practice Applied Research.</p></EuiText></EuiFlexItem>
                    <EuiFlexItem grow={false}><EuiImage size="m" hasShadow src={profilePhoto}/></EuiFlexItem>
                </EuiFlexGroup>
            <EuiFlexGroup>
                <EuiFlexItem>
                <EuiSpacer size='m' /><EuiText><h2><u>Goals</u></h2></EuiText>
                <EuiSpacer />
                <EuiFlexGroup wrap gutterSize='xs'>
                <EuiFlexItem><EuiCard textAlign="left" title="Short Term Goals" description={"(1-3 years)"} titleSize='xs'>
                <EuiText size="s">
                <ul>{this.state.shortTerm && this.state.shortTerm.map((skill, i) => <li key={i}>{skill}</li>)}</ul>
                </EuiText></EuiCard></EuiFlexItem>
                <EuiFlexItem><EuiCard textAlign="left" title="Mid Term Goals" description={"(3-5 years)"} titleSize='xs'>
                <EuiText size="s">
                <ul>{this.state.midTerm && this.state.midTerm.map((skill, i) => <li key={i}>{skill}</li>)}</ul>
                </EuiText></EuiCard></EuiFlexItem>
                <EuiFlexItem><EuiCard textAlign="left" title="Long Term Goals" description={"(5+ years)"} titleSize='xs'>
                <EuiText size="s">
                <ul>{this.state.longTerm && this.state.longTerm.map((skill, i) => <li key={i}>{skill}</li>)}</ul>
                </EuiText></EuiCard></EuiFlexItem>
                </EuiFlexGroup>
                </EuiFlexItem>
                </EuiFlexGroup>
                {/* <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                <EuiSpacer size='m' /><EuiText><h3>Testimonials</h3></EuiText>
                <EuiSpacer /><EuiFlexGroup>
                <EuiCard textAlign="left" title="1" description={"1"} titleSize='xs'>
                <EuiText size="s">
                Testimonial 1
                </EuiText></EuiCard>
                <EuiCard textAlign="left" title="2" description={"1"} titleSize='xs'>
                <EuiText size="s">
                Testimonial 2
                </EuiText></EuiCard>
                <EuiCard textAlign="left" title="3" description={"1"} titleSize='xs'>
                <EuiText size="s">
                Testimonial 3
                </EuiText></EuiCard>
                <EuiCard textAlign="left" title="4" description={"1"} titleSize='xs'>
                <EuiText size="s">
                Testimonial 4
                </EuiText></EuiCard>
                </EuiFlexGroup>
                </EuiFlexItem>
                </EuiFlexGroup> */}
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { About }